"use strict";
exports.isArrayLike = (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArrayLike.js.map


//////////////////
// WEBPACK FOOTER
// /www/sms-simulator/sms-front/~/rxjs/util/isArrayLike.js
// module id = ../../../../rxjs/util/isArrayLike.js
// module chunks = 3